import { useEffect, useState } from "react";
import { Languages, X } from "lucide-react";

export const TranslateWarning = () => {
  const [on, setOn] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("lala_translate_warn_dismissed") === "1");

  useEffect(() => {
    const check = () => {
      const html = document.documentElement;
      const lang = (html.getAttribute("lang") || "").toLowerCase();
      const translated = html.classList.contains("translated-ltr") || html.classList.contains("translated-rtl")
        || (lang && !lang.startsWith("es"));
      setOn(translated);
    };
    check();
    const obs = new MutationObserver(check);
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class", "lang"] });
    return () => obs.disconnect();
  }, []);

  if (!on || dismissed) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[95] max-w-xl w-[92%] rounded-xl bg-[#FFF8E6] border-2 border-[#D4A437] shadow-lg p-4 flex items-start gap-3" data-testid="translate-warning">
      <Languages size={20} className="text-[#8a6a14] shrink-0 mt-0.5" />
      <div className="text-sm text-[#6b5210]">
        <strong>Tu navegador está traduciendo esta página automáticamente.</strong>{" "}
        LALA Elite ya está en español — la traducción automática puede mostrar nombres extraños
        (por ejemplo, "Salpicadero" en lugar de "Vista general"). Te recomendamos desactivar el
        traductor para esta página.
      </div>
      <button
        onClick={() => { sessionStorage.setItem("lala_translate_warn_dismissed", "1"); setDismissed(true); }}
        className="shrink-0 p-1 rounded hover:bg-[#D4A437]/20 text-[#8a6a14]"
        data-testid="translate-warning-dismiss"
        aria-label="Cerrar aviso"
      >
        <X size={16} />
      </button>
    </div>
  );
};
